<template>
  <div>
    <div>
      <b-card>
        <h6 class="mb-4 font-weight-bold">Filter</h6>
        <b-row>
          <b-col>
            <b-form-group label="Month(s)">
              <custom-select
                label="name"
                v-model="filterMonth"
                :options="monthFilter.filters"
                placeholder="Select month"
              />
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group label="Year(s)">
              <custom-select
                label="year"
                v-model="filterYear"
                :options="yearFilter.filters"
                placeholder="Select year"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <div class="button-project mt-5 d-flex justify-content-end">
          <b-button
            class="reset mr-3"
            variant="outline-warning"
            @click="resetFilter"
          >
            Reset Filter
          </b-button>
          <b-button
            class="next"
            variant="warning"
            @click="applyFilter"
          >
            Apply Filter
          </b-button>
        </div>
      </b-card>
    </div>
    <div class="mt-3">
      <b-card>
        <div class="mb-2 mt-2 text-warning">
          <b-button variant="outline-warning pl-4 pr-4 p-2" @click="exportRecapAttendance">
            Export Data
          </b-button>
        </div>
        <div class="overflow-auto">
          <b-row v-show="!employee.length">
            <b-col>
              <div align="center">
                <img src="@/assets/icon-no-invoice.png" />
              </div>
            </b-col>
          </b-row>
          <b-table
            ref="table"
            class="mt-2 text-center align-middle"
            v-show="employee.length"
            :items="getEmployee"
            :fields="fields"
            :per-page="perPage"
            :current-page="currentPage"
            :sort-by.sync="sortBy"
            striped
            bordered
            responsive
            @change="$refs.table.refresh()"
          >
            <template #cell(id)="{ index }">
              <div>
                {{ index +  1 }}
              </div>
            </template>
            <template ref="date" v-for="date in getMonthDates()" :slot="`cell(${date})`" slot-scope="{ item }">
                {{ findAttendanceTypeInDate(item, date) }}
            </template>
          </b-table>
          <div class="d-flex justify-content-between">
            <div>
              <span>Show</span>
              <b-form-select
                v-model="perPage"
                :options="pageOptions"
                @change="$refs.table.refresh()"
                class="page-option ml-2 mr-2 w-auto"
                size="sm"
              />
              <span>Entries</span>
            </div>
            <div>
              <b-pagination
                class="mb-0"
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                pills
                hide-goto-end-buttons
              />
              <span class="show-entries mr-auto">
                {{
                `Show ${
                  totalRows === 0 ? 0 : (currentPage - 1) * perPage + 1
                } to ${
                  totalRows > currentPage * perPage
                    ? currentPage * perPage
                    : totalRows
                } of ${totalRows} entries`
              }}
              </span>
            </div>
          </div>
        </div>
      </b-card>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import * as XLSX from 'xlsx-js-style'

export default {
  data() {
    return {
      monthFilter: {
        show: true,
        filters: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ]
      },
      filterMonth: [],
      filterYear: new Date().getFullYear(),
      yearList: [],
      yearFilter: {
        show: true,
        filters: []
      },
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      totalPage: 0,
      sortBy: 'name',
      pageOptions: [10, 20, 50, 100],
      attendancePerMonth: [],
      attendanceDetailPerMonth: [],
      attendanceRecap: [],
      attendanceType: [],
      fields: [],
      dates: [],
      employee: [],
      attendanceEmployees: []
    }
  },
  computed: {
    rows() {
      return this.employee.length
    }
  },
  methods: {
    getMonthDates() {
      const currentDate = new Date()
      let year = currentDate.getFullYear()
      let month = currentDate.getMonth()
      if (this.filterMonth && this.filterYear) {
        const monthIndex = this.monthFilter.filters.findIndex(monthName => monthName === this.filterMonth)
        if (monthIndex !== -1) {
          month = monthIndex
        }
        year = parseInt(this.filterYear)
      }
      const startDate = new Date(year, month, 1)
      const endDate = new Date(year, month + 1, 0)
      const daysInMonth = Math.floor((endDate - startDate) / (1000 * 60 * 60 * 24)) + 1
      const dates = []
      for (let day = 1; day <= daysInMonth; day++) {
        const date = new Date(startDate.getTime() + day * (1000 * 60 * 60 * 24))
        dates.push(date.toISOString().substr(0, 10))
      }
      dates.sort((a, b) => new Date(a) - new Date(b))
      this.dates = dates
      return dates
    },
    formatDate(date) {
      const options = { day: 'numeric' }
      const formattedDate = new Date(date).toLocaleDateString('en-US', options)
      return formattedDate
    },
    convertStringMonthToNumber(monthString) {
      const month = this.monthFilter.filters.findIndex(item => item === monthString)
      return month + 1
    },
    findAttendanceTypeNameById(typeId) {
      const type = this.attendanceType.find(type => type.id === typeId)
      return type ? type.name : ''
    },
    findAttendanceIdByemployeeId(employeeId) {
      const attendance = this.attendancePerMonth.find(attendance => attendance.employeeId === employeeId)
      return attendance ? attendance.id : ''
    },
    seperateDateAndTime(dateTime) {
      return dateTime.substr(0, 10)
    },
    getLastDayOfMonth() {
      const today = new Date()
      const year = today.getFullYear()
      const month = today.getMonth()

      const nextMonth = new Date(year, month + 1, 0)
      return nextMonth.getDate()
    },
    async getDetailAttendance() {
      const numberMonth = this.convertStringMonthToNumber(this.filterMonth)
      const lastDay = this.getLastDayOfMonth()
      try {
        const { data } = await api.presence.listDetail({
          page: 1,
          pageSize: 100000,
          Filters: `AttendanceDate>=${this.filterYear}-${numberMonth}-01, AttendanceDate<=${this.filterYear}-${numberMonth}-${lastDay}`
        })
        this.attendanceDetailPerMonth = []
        this.attendanceDetailPerMonth = data.data.map(item => {
          return {
            id: item.id,
            attendanceId: item.attendanceId,
            attendanceDate: this.seperateDateAndTime(item.attendanceDate),
            attendanceTypeId: item.attendanceTypeId,
            attendanceTypeName: this.findAttendanceTypeNameById(item.attendanceTypeId)
          }
        })
      } catch (error) {
        console.log(error)
      }
      this.getAttendance()
    },
    async getEmployee() {
      try {
        const { data } = await api.employee.list({
          page: this.currentPage,
          pageSize: this.perPage,
          sorts: 'fullName',
          Filters: 'Status==True'
        })
        this.employee = []
        this.totalRows = data.length !== 0 ? data.totalData : 0
        this.totalPage = data.totalPage
        this.employee = data.data.map((item, i) => {
          return {
            id: item.id,
            fullName: item.fullName,
            empolyeeNo: item.employeeNo,
            _rowVariant: i % 2 === 0 ? 'warning' : null,
            attendanceId: this.findAttendanceIdByemployeeId(item.id)
          }
        })
      } catch (error) {
        console.log(error)
      }
      return this.employee
    },
    async getAttendance() {
      try {
        const { data } = await api.presence.list({
          page: 1,
          pageSize: 10000,
          Filters: `month==${this.filterMonth}, year==${this.filterYear}`
        })
        this.attendancePerMonth = []
        this.attendancePerMonth = data.data
      } catch (error) {
        console.log(error)
      }
    },
    async getTypeAttendanceEmployee() {
      try {
        const { data } = await api.presence.getTypeAttendance()
        this.attendanceType = data.data
      } catch (error) {
        console.log(error)
      }
    },
    async exportRecapAttendance() {
      let dataEmployee = []
      try {
        const { data } = await api.employee.list({
          page: 1,
          pageSize: 10000,
          sorts: 'fullName',
          Filters: 'Status==True'
        })
        dataEmployee = data.data.map(item => {
          const employeeData = {
            Name: item.fullName,
            ID: item.employeeNo,
            Realization: this.findRealizationByEmployeeId(item.id),
            Percentage: this.findPercentageByEmployeeId(item.id),
            Status: this.findStatusByEmployeeId(item.id)
          }
          this.getMonthDates().forEach(date => {
            const attendanceId = this.findAttendanceIdByemployeeId(item.id)
            const attendance = this.attendanceDetailPerMonth.find(attendance => attendance.attendanceId === attendanceId && attendance.attendanceDate === date)
            employeeData[date] = attendance ? attendance.attendanceTypeName : '-'
          })
          return employeeData
        })
      } catch (error) {
        console.log(error)
      }
      const wsData = [
        [
          {
            v: `${this.filterMonth} ${this.filterYear}`,
            s: {
              fill: { bgColor: { indexed: 64 }, fgColor: { rgb: 'ffcc26' } },
              font: { bold: true, sz: 20, color: { rgb: 'ffffff' } },
              alignment: { horizontal: 'center' }
            }
          },
          {},
          {},
          {},
          {
            v: 'Tanggal Absen',
            s: {
              fill: { bgColor: { indexed: 64 }, fgColor: { rgb: 'ffcc26' } },
              font: { bold: true, sz: 20, color: { rgb: 'ffffff' } },
              alignment: { horizontal: 'center' }
            }
          }
        ],
        [],
        [
          {
            v: 'Name',
            s: {
              fill: { bgColor: { indexed: 64 }, fgColor: { rgb: 'ffcc26' } },
              font: { bold: true, color: { rgb: 'ffffff' } },
              alignment: { horizontal: 'center' },
              border: {
                bottom: { style: 'thin', color: { rgb: '000000' } },
                left: { style: 'thin', color: { rgb: '000000' } },
                right: { style: 'thin', color: { rgb: '000000' } },
                top: { style: 'thin', color: { rgb: '000000' } }
              }
            }
          },
          {
            v: 'ID',
            s: {
              fill: { bgColor: { indexed: 64 }, fgColor: { rgb: 'ffcc26' } },
              font: { bold: true, color: { rgb: 'ffffff' } },
              alignment: { horizontal: 'center' },
              border: {
                bottom: { style: 'thin', color: { rgb: '000000' } },
                left: { style: 'thin', color: { rgb: '000000' } },
                right: { style: 'thin', color: { rgb: '000000' } },
                top: { style: 'thin', color: { rgb: '000000' } }
              }
            }
          },
          {
            v: 'Realization',
            s: {
              fill: { bgColor: { indexed: 64 }, fgColor: { rgb: 'ffcc26' } },
              font: { bold: true, color: { rgb: 'ffffff' } },
              alignment: { horizontal: 'center' },
              border: {
                bottom: { style: 'thin', color: { rgb: '000000' } },
                left: { style: 'thin', color: { rgb: '000000' } },
                right: { style: 'thin', color: { rgb: '000000' } },
                top: { style: 'thin', color: { rgb: '000000' } }
              }
            }
          },
          {
            v: 'Percentage',
            s: {
              fill: { bgColor: { indexed: 64 }, fgColor: { rgb: 'ffcc26' } },
              font: { bold: true, color: { rgb: 'ffffff' } },
              alignment: { horizontal: 'center' },
              border: {
                bottom: { style: 'thin', color: { rgb: '000000' } },
                left: { style: 'thin', color: { rgb: '000000' } },
                right: { style: 'thin', color: { rgb: '000000' } },
                top: { style: 'thin', color: { rgb: '000000' } }
              }
            }
          },
          {
            v: 'Status',
            s: {
              fill: { bgColor: { indexed: 64 }, fgColor: { rgb: 'ffcc26' } },
              font: { bold: true, color: { rgb: 'ffffff' } },
              alignment: { horizontal: 'center' },
              border: {
                bottom: { style: 'thin', color: { rgb: '000000' } },
                left: { style: 'thin', color: { rgb: '000000' } },
                right: { style: 'thin', color: { rgb: '000000' } },
                top: { style: 'thin', color: { rgb: '000000' } }
              }
            }
          },
          ...this.getMonthDates().map(date => ({
            v: date,
            s: {
              fill: { bgColor: { indexed: 64 }, fgColor: { rgb: 'ffcc26' } },
              font: { bold: true, color: { rgb: 'ffffff' } },
              alignment: { horizontal: 'center' },
              border: {
                bottom: { style: 'thin', color: { rgb: '000000' } },
                left: { style: 'thin', color: { rgb: '000000' } },
                right: { style: 'thin', color: { rgb: '000000' } },
                top: { style: 'thin', color: { rgb: '000000' } }
              }
            }
          }))
        ],
        ...dataEmployee.map(item =>
          Object.values({
            ...item,
            Name: { v: item.Name, s: { alignment: { horizontal: 'left' } } },
            ID: { v: item.ID, s: { alignment: { horizontal: 'left' } } },
            Realization: { v: item.Realization, s: { alignment: { horizontal: 'center' } } },
            Percentage: { v: item.Percentage, s: { alignment: { horizontal: 'center' } } },
            Status: { v: item.Status, s: { alignment: { horizontal: 'center' } } }
          })
        )
      ]
      const ws = XLSX.utils.aoa_to_sheet(wsData)
      // merge from A1 to D1
      ws['!merges'] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 3 } }
      ]
      // merge from E1 to last date
      ws['!merges'].push({ s: { r: 0, c: 4 }, e: { r: 0, c: this.getMonthDates().length + 4 } })
      // set column width
      ws['!cols'] = [
        { wch: 30 },
        { wch: 15 },
        { wch: 15 },
        { wch: 15 },
        ...this.getMonthDates().map(date => ({ wch: 15 }))
      ]
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws, `Recap Attendance ${this.filterMonth} ${this.filterYear}`)
      XLSX.writeFile(wb, `Recap Attendance ${this.filterMonth} ${this.filterYear}.xlsx`)
    },
    findPercentageByEmployeeId(id) {
      const attendance = this.attendancePerMonth.find(attendance => attendance.employeeId === id)
      return attendance ? `${(attendance.percentage).toFixed(2)}%` : 0
    },
    findStatusByEmployeeId(id) {
      const attendance = this.attendancePerMonth.find(attendance => attendance.employeeId === id)
      return attendance ? attendance.status : ''
    },
    findRealizationByEmployeeId(id) {
      const attendance = this.attendancePerMonth.find(attendance => attendance.employeeId === id)
      return attendance ? attendance.realization : 0
    },
    getDate(date) {
      const dateSplit = date.split('-')
      const dateOnly = dateSplit[2]
      if (dateOnly.length === 2 && dateOnly[0] === '0') {
        return dateOnly[1]
      } else {
        return dateOnly
      }
    },
    updateFields() {
      this.fields = [
        { key: 'id', label: 'No', thClass: 'text-center' },
        { key: 'fullName', label: 'Name', thClass: 'text-center', tdClass: 'text-center', sortable: false },
        ...this.getMonthDates().map(date => ({
          key: date,
          label: this.formatDate(date),
          class: 'text-center'
        }))
      ]
    },
    getYearList(startYear, endYear) {
      const years = []
      for (let year = startYear; year <= endYear; year++) {
        years.push(year)
      }
      return years
    },
    applyFilter() {
      this.$refs.table.refresh()
      this.getMonthDates()
    },
    resetFilter() {
      this.filterMonth = this.monthFilter.filters[new Date().getMonth()]
      this.filterYear = new Date().getFullYear()
      this.$refs.table.refresh()
    },
    findAttendanceTypeInDate(item, date) {
      const attendanceId = this.findAttendanceIdByemployeeId(item.id)
      const attendance = this.attendanceDetailPerMonth.find(attendance => attendance.attendanceId === attendanceId && attendance.attendanceDate === date)
      return attendance ? attendance.attendanceTypeName : '-'
    }
  },
  watch: {
    filterMonth() {
      this.updateFields()
      this.getDetailAttendance()
      this.getAttendance()
    },
    filterYear() {
      this.updateFields()
      this.getDetailAttendance()
      this.getAttendance()
    }
  },
  created() {
    this.filterMonth = this.monthFilter.filters[new Date().getMonth()]
    const startYear = 2021
    const currentDate = new Date()
    for (let i = startYear; i <= currentDate.getFullYear(); i++) {
      this.yearFilter.filters.push(i)
    }
    this.getTypeAttendanceEmployee()
    this.updateFields()
  }
}
</script>

<style lang="scss" scoped>
*{
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
</style>
